/**
 * @desc Animation names.
 * @example
 * import * as ANIMATION_NAMES from 'constants/animation';
 * console.log( ANIMATION_NAMES.fadeInSlideX );
 */

// export all animation names
export const ANIMATION_NAMES = {
	FADE_IN_SLIDE_X: 'fadeInSlideX',
	FADE_IN_SLIDE_Y: 'fadeInSlideY',
	FADE_IN_OUT: 'fadeInOut'
};
